import React from "react";
import Header from "../../Header";
import { UberTable, RowDefinition } from "../../tables/UberTable";

const LearnersProgress = ({ course }) => {
  const rowDefinition = [
    {
      title: "Learner",
      attribute_key: "full_name",
      sort_key: "full_name",
      render: (learner) => learner.full_name || "N/A",
    },
    {
      title: "Organization Name",
      attribute_key: "organization_name",
      sort_key: "organization_name",
      render: (learner) => learner.organization_name || "N/A",
    },
    {
      title: "Lessons Completed",
      attribute_key: "lessons_completed",
      sort_key: "lessons_completed",
      textAlignment: "center",
      render: (learner) =>
        learner.lessons_completed === 0
          ? "Not Started"
          : `${learner.lessons_completed} / ${learner.total_lessons}`,
    },
    {
      title: "Quizzes Taken",
      attribute_key: "quiz_progress",
      sort_key: "quiz_taken",
      textAlignment: "center",
      render: (learner) => {
        if (
          learner.total_quizzes === 0 ||
          learner.total_quizzes === undefined
        ) {
          return <i className="fas fa-horizontal-rule text-muted"></i>;
        } else if (!learner.quiz_taken || learner.quiz_taken === 0) {
          return "Not Started";
        } else {
          return `${learner.quiz_taken} / ${learner.total_quizzes}`;
        }
      },
    },
  ];

  // Conditional rendering if no course is found
  if (!course) {
    return (
      <div className="learners-progress">
        <Header title="Learners Progress" />
        <p>Course information not available.</p>
      </div>
    );
  }

  return (
    <div className="learners-progress">
      <Header title="Learners Progress" />
      <h2 className="course-title">Course: {course.title}</h2>

      <UberTable
        rowDefinition={rowDefinition}
        searchType={`learner-progress-${course.id}`}
        showTags={false}
        sort_key="full_name"
        direction="asc"
        additionalOptions={(learner) => (
          <a
            href={`/courses/${course.id}/learners/${learner.id}`}
            className="btn btn-link"
            title="View Submission"
          >
            View Submissions
          </a>
        )}
      />
    </div>
  );
};

export default LearnersProgress;
